import { isBrowser as e } from "./highrise1350.mjs";
const t = e && "loading" in document.createElement("img");
export {
  t as isImageSupportNativeLazy
};
